(function waitForAnalyticsVerification() {
  if (window.vdgVerified || window.vdgWhitelisted) {
    if (window.vdgRiskScore >= 0.8 || window.vdgWhitelisted) {
      console.log('[✅ GTM tracking active]');

      // ========== PAGE VIEW ==========
      analytics.subscribe('page_viewed', function (event) {
        window.dataLayer.push({
          event: 'eec_page_view',
          user_data: {
            visitorId: window.vdgFingerprint || null
          },
          page_data: {
            page_type: event.context?.pageType || null,
            collection: event.context?.collection?.title || null
          },
          event_data: {
            timestamp: Date.now()
          }
        });
      });

      // ========== PRODUCT VIEW ==========
      analytics.subscribe('product_viewed', function (event) {
        window.dataLayer.push({
          event: 'eec_product_view',
          ecommerce: {
            detail: {
              products: [{
                id: event.data.product_variant.sku || event.data.product_variant.id,
                name: event.data.product_variant.name,
                price: event.data.product_variant.price,
                brand: event.data.product.vendor,
                category: event.context.collection?.title || '',
                variant: event.data.product_variant.title,
              }]
            }
          },
          user_data: {
            visitorId: window.vdgFingerprint || null
          },
          event_data: {
            timestamp: Date.now()
          }
        });
      });

      // ========== ADD TO CART ==========
      analytics.subscribe('product_added_to_cart', function (event) {
        window.dataLayer.push({
          event: 'eec_add_to_cart',
          ecommerce: {
            add: {
              products: [{
                id: event.data.cart_line.merchandise.sku || event.data.cart_line.merchandise.id,
                name: event.data.cart_line.merchandise.product.title,
                price: event.data.cart_line.merchandise.price.amount,
                brand: event.data.cart_line.merchandise.product.vendor,
                category: event.data.cart_line.merchandise.product?.type || '',
                variant: event.data.cart_line.merchandise.title,
                quantity: event.data.cart_line.quantity
              }]
            }
          },
          user_data: {
            visitorId: window.vdgFingerprint || null
          },
          event_data: {
            timestamp: Date.now()
          }
        });
      });

      // ========== VIEW CART ==========
      analytics.subscribe('cart_viewed', function (event) {
        window.dataLayer.push({
          event: 'eec_view_cart',
          ecommerce: {
            currencyCode: event.data.cart.currency || 'EUR',
            items: (event.data.cart.lines || []).map(function (line) {
              return {
                id: line.merchandise.sku || line.merchandise.id,
                name: line.merchandise.product.title,
                price: line.merchandise.price.amount,
                brand: line.merchandise.product.vendor,
                category: line.merchandise.product?.type || '',
                variant: line.merchandise.title,
                quantity: line.quantity
              };
            })
          },
          user_data: {
            visitorId: window.vdgFingerprint || null
          },
          event_data: {
            timestamp: Date.now()
          }
        });
      });

      // ========== BEGIN CHECKOUT ==========
      analytics.subscribe('checkout_started', function (event) {
        window.dataLayer.push({
          event: 'eec_begin_checkout',
          ecommerce: {
            checkout: {
              actionField: { step: 1 },
              products: (event.data.checkout.line_items || []).map(function (item) {
                return {
                  id: item.variant.sku || item.variant.id,
                  name: item.product.title,
                  price: item.price.amount,
                  brand: item.product.vendor,
                  category: item.product?.type || '',
                  variant: item.variant.title,
                  quantity: item.quantity
                };
              })
            }
          },
          user_data: {
            visitorId: window.vdgFingerprint || null
          },
          event_data: {
            timestamp: Date.now()
          }
        });
      });

      // ========== PURCHASE ==========
      analytics.subscribe('checkout_completed', function (event) {
        window.dataLayer.push({
          event: 'eec_purchase',
          ecommerce: {
            purchase: {
              actionField: {
                id: event.data.checkout.order_id,
                affiliation: 'Online Store',
                revenue: event.data.checkout.total_price.amount,
                shipping: event.data.checkout.shipping_line?.price.amount || 0,
                tax: event.data.checkout.total_tax.amount || 0
              },
              products: (event.data.checkout.line_items || []).map(function (item) {
                return {
                  id: item.variant.sku || item.variant.id,
                  name: item.product.title,
                  price: item.price.amount,
                  brand: item.product.vendor,
                  category: item.product?.type || '',
                  variant: item.variant.title,
                  quantity: item.quantity
                };
              })
            }
          },
          user_data: {
            visitorId: window.vdgFingerprint || null
          },
          event_data: {
            timestamp: Date.now()
          }
        });
      });

    } else {
      console.warn('[⛔ GTM blocked: score below threshold]');
    }
  } else {
    setTimeout(waitForAnalyticsVerification, 200);
  }
})();
